function About() {
  return (
    <main>
      <div className="bg-white py-12 px-6">
    <div className="max-w-3xl mx-auto text-center">
      {/* About Us Heading */}
      <h4 className="text-3xl font-extrabold text-gray-900 mb-6">
        ABOUT US
      </h4>

      {/* About Us Description */}
      <p className="text-gray-700 text-justify leading-relaxed mb-6">
        Welcome to the Cotton University Student Information Management System! Seamlessly connecting students, faculty, and administration for a smoother academic experience.
      </p>

      {/* Developer Information */}
      <p className="text-gray-700 text-justify leading-relaxed mb-6">
        Cotton University Student Management System is developed and maintained by <b className="text-blue-600">YROS Software</b>, Guwahati, Assam.
      </p>
      
      {/* Contact Information */}
      <p className="text-gray-700 text-justify leading-relaxed">
        For inquiries about new software development projects—including AI-based applications, website development, web app development, or mobile app development—please contact us at{' '}
        <a href="tel:7896922693" className="text-blue-600 font-semibold hover:underline">
          7896922693
        </a>{' '}
        or email{' '}
        <a href="mailto:contactyros@gmail.com" className="text-blue-600 font-semibold hover:underline">
          contactyros@gmail.com
        </a>.
      </p>
    </div>
  </div>
    </main>
  )
}

export default About